// Libarary Class
import { Component, OnInit, ViewEncapsulation, Inject, AfterViewInit, OnDestroy, } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
const _ = require('lodash');
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { ToastrService } from 'ngx-toastr';
import * as $ from 'jquery';
import { Router } from '@angular/router';

// Service Class
import { BroadcastService } from './../../../../services/infrastructure/broadcaster.service';
import { ConfigService } from './../../../../services/infrastructure/config.service';
import { LoaderService } from './../../../../services/infrastructure/loader.service';
import { LocalStorageService } from './../../../../services/infrastructure/local-storage.service';

// Class
import { MasterConstants } from './../../../../common/constants/master-constants';
import { DashboardFilter } from './../../../../models/DashboardFilter';
import { CommonService } from '../../../../services/common/common.service';
import {
  ContactType,
  CppDeliveryInstructionFormsData,
  CppDeliveryInstructionsData,
  LineError,
} from './cpp-create-edit-delivery-instructions-data';
import { CppDeliveryInstructionService } from '../../../../services/cpp/cpp-delivery-instruction.service';

import { DatePipe } from '@angular/common';
import { ConfirmDialogComponent } from '../../../../common/components/confirm-dialog/confirm-dialog.component';
import { Subscription } from 'rxjs';
import { LolLoggerService } from './../../../../common/shared/lol-logger.service';

@Component({
  selector: 'app-cpp.cpp-create-edit-delivery-instructions',
  templateUrl: './cpp-create-edit-delivery-Instructions.component.html',
  animations: [
    trigger('detailExpand', [
      state(
        'collapsed',
        style({ height: '0px', minHeight: '0', display: 'none' })
      ),
      state('expanded', style({ height: '*' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      ),
    ]),
    trigger('fadeInOut', [
      transition(':enter', [
        // :enter is alias to 'void => *'
        style({ opacity: 0 }),
        animate(400, style({ height: '*', opacity: 1 })),
      ]),
      transition(':leave', [
        // :leave is alias to '* => void'
        animate(400, style({ height: '0px', opacity: 0 })),
      ]),
    ]),
  ],
  styleUrls: ['./cpp-create-edit-delivery-instructions.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CppCreateEditDeliveryInstructionsComponent
  implements OnInit, AfterViewInit, OnDestroy {
  private subscription = new Array<Subscription>();

  shipToData: any;
  deliverToData: any;
  dashboardFilter: DashboardFilter;
  displayedColumns: string[] = [
    'packagedType',
    'contactType',
    'firstName',
    'lastName',
    'phone',
    'deliveryInstructions',
    'action',
  ];
  deliverTo: any;
  enable: any;
  editToolKit: any;
  isSearchClicked: any;
  deliveryInstructionDS: MatTableDataSource<CppDeliveryInstructionsData>;
  originalProductItemsDataSource: MatTableDataSource<CppDeliveryInstructionsData>;
  errorsList: Array<string> = [];
  error = false;
  errorMsgs = new Array();
  showErrorBlock = false;
  currentErrorRow = 1;
  index = 0;
  nextErrorId = 0;
  isEditMode = false;
  hasChangeAdded = false;
  accessTypeMode = false;
  deliveryInstruction: MatTableDataSource<any>;
  contactTypeList: any = [];
  deliveryInstructionList: any = [];
  selectedFormData: CppDeliveryInstructionFormsData;
  returnAccountNo: number;
  enableCreate: boolean = true;
  isSubmitEnable: boolean = false;
  orderViewtoggle: boolean = false;
  shipToDataLoading: boolean = true;
  isSaveClicked: boolean = false;
  MaxlengthErrorMsg: string = '';
  packagedTypeList: any = [{ id: 'BULK', value: 'BULK' }, { id: 'PACKAGED', value: 'PACKAGED' }];
  deliveryInstructionsList: any = [{ id: 'PJK', value: 'Pallet Jack Required' }, { id: 'DRA', value: 'Driver Required Assistance' }, { id: 'UNMAN', value: 'Unmanned Location' }];
  isDeliveryInstructionsDisabled: boolean = true;

  constructor(
    public http: HttpClient,
    @Inject('BASE_URL') public baseUrl: string,
    private router: Router,
    private broadcastService: BroadcastService,
    private configService: ConfigService,
    private cppDeliveryInstructionService: CppDeliveryInstructionService,
    private localStorageService: LocalStorageService,
    private loaderService: LoaderService,
    private matDialog: MatDialog,
    public datepipe: DatePipe,
    private toastrService: ToastrService,
    private commonService: CommonService
  ) {
    this.dashboardFilter = new DashboardFilter();
    this.selectedFormData = new CppDeliveryInstructionFormsData();

    this.subscription.push(this.broadcastService
      .on<any>(this.configService.DATA_CHANGE_ADDED)
      .subscribe((data) => {
        if (data.hasChangeAdded != undefined) {
          this.hasChangeAdded = data.hasChangeAdded;
        }
      }));
  }

  ngOnInit() {
    if (this.localStorageService.get(MasterConstants.DELIVERY_INSTRUCTIONS_ERROR_MESSAGE)) {
      const ErrorMessages = JSON.parse(
        this.localStorageService.get(MasterConstants.DELIVERY_INSTRUCTIONS_ERROR_MESSAGE)
      );
      if (ErrorMessages.length > 0) {
        this.MaxlengthErrorMsg = ErrorMessages.filter((x) => x.configName == 'DeliveryInstructionMaxLenError')[0].configValue;
      }
    }

    this.loaderService.setLoaderStatus(true);
    this.getShipToAndDeliverToData();
    // this.GetMasterData();
    this.contactTypeList = ContactType;
    // this.deliveryInstructionList = DeliveryCodeList;

    this.errorMsgs = new Array();

    this.accessTypeMode = false;
    setTimeout((x) => {
      this.accessTypeMode = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.CROP_PROTECTION_PRODUCT_ORDER);

      // Get Return Request Id for edit
      if (this.cppDeliveryInstructionService.editDeliveryAccountNo) {
        this.returnAccountNo = this.cppDeliveryInstructionService.editDeliveryAccountNo;
        this.isEditMode = true;
        this.enableCreate = false;
        this.getDeliveryInstructionsDetails();
      }
      else {
        this.enableCreate = true;
      }

      this.loaderService.setLoaderStatus(false);
    }, 500);
  }

  // ngAfterViewInit
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setSeedEditPageHeight();
  }

  onAddRecord() {
    const blankData = new CppDeliveryInstructionsData();
    this.isSubmitEnable = true;
    // assigning id based on the data present in last of array
    const prevData =
      this.deliveryInstructionDS?.data == undefined
        ? []
        : this.deliveryInstructionDS.data;
    if (prevData && prevData.length < 4) {
      blankData.id =
        prevData.length == 0 ? prevData.length + 1 : prevData.slice(-1)[0].id + 1;
      blankData.packagedType = 'BULK'
      blankData.contactType = '';
      blankData.firstName = '';
      blankData.lastName = '';
      blankData.phoneNumber = '';
      blankData.lineErrors = { itemId: blankData.id, errors: [] };
      blankData.lineError = false;
      blankData.toBeValidated = true;
      blankData.isActive = true;
      blankData.deliveryInstructions = '';
      blankData.packagedTypeDisabled = false;
      if (prevData.length > 0) {
        prevData.map((x) => {
          x['toBeValidated'] = false;
          return x;
        });
      }
      this.deliveryInstructionDS = new MatTableDataSource([
        ...prevData,
        blankData,
      ]);
      this.originalProductItemsDataSource = new MatTableDataSource(JSON.parse(JSON.stringify(this.deliveryInstructionDS.data)));
      this.enableSaveDeliveryInstruction();
    }
    else {
      this.toastrService.error(
        'Cannot add more than four records.'
      );
    }
  }

  deleteProducts(data: any) {
    const title = 'Delete';
    const message = 'Do you want to delete this saved record?';
    const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '480px',
      data: {
        title: title,
        message: message,
        labelYes: 'Yes',
        labelNo: 'No',
        dialogType: 'confirm',
      },
    });

    this.subscription.push(dialogRef.afterClosed().subscribe((result) => {
      // If user selected Yes
      if (result == true) {
        this.loaderService.setLoaderStatus(true);
        if (!data.contactId) {
          this.deliveryInstructionDS = new MatTableDataSource(this.deliveryInstructionDS?.data.filter(x => x.id != data.id));
          this.originalProductItemsDataSource = new MatTableDataSource(JSON.parse(JSON.stringify(this.deliveryInstructionDS?.data.filter(x => x.id != data.id))));
          if (this.deliveryInstructionDS?.data.length == 0) {
            this.router.navigate(['/cpp/cpp-delivery-instructions']);
          }
          this.loaderService.setLoaderStatus(false);
        } else {
          this.subscription.push(this.cppDeliveryInstructionService
            .deleteDeliveryInstruction(data.contactId)
            .subscribe(
              (result) => {
                this.loaderService.setLoaderStatus(false);
                this.toastrService.success(
                  'Delivery Instructions deleted successfully.'
                );
                this.deliveryInstructionDS = new MatTableDataSource(this.deliveryInstructionDS?.data.filter(x => x.id != data.id));
                this.originalProductItemsDataSource = new MatTableDataSource(JSON.parse(JSON.stringify(this.deliveryInstructionDS?.data.filter(x => x.id != data.id))));
                if (this.deliveryInstructionDS?.data.length == 0) {
                  this.router.navigate(['/cpp/cpp-delivery-instructions']);
                }
              },
              (error) => LolLoggerService.error(error)
            ));
        }
      }
    }));
  }

  onGridInputChange(data: CppDeliveryInstructionsData, fieldName: string) {
    this.isSubmitEnable = true;
    // Find index of specific object using findIndex method.
    const tempData = this.deliveryInstructionDS?.data;
    const objIndex = tempData.findIndex((obj) => obj.id == data.id);

    // Update object's name property.
    tempData[objIndex][fieldName] = data[fieldName];
    this.deliveryInstructionDS = new MatTableDataSource(tempData);

    //this.validateOrder()
    this.validateDeliveryFeildDS(tempData[objIndex], fieldName)

    if (fieldName == 'packagedType') {
      if (data.packagedType == 'PACKAGED') {
        data.isDeliveryInstructionsDisabled = false;
      } else {
        data.isDeliveryInstructionsDisabled = true;
        data.deliveryInstructions = '';
        data.selectedDeliveryInstructions = new Array<string>();
      }
    }
  }

  onAccountInputChange() {
    if (this.selectedFormData.accountNumber) {
      this.getDeliveryInstructionsDetailsByAccount(this.selectedFormData.accountNumber)
      if (this.deliveryInstructionDS && this.deliveryInstructionDS?.data) {
        const res = this.CompareArray(this.deliveryInstructionDS.data, this.originalProductItemsDataSource.data)
        this.isSubmitEnable = !res;
      }
    }
  }

  getDeliveryInstructionsDetails() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.cppDeliveryInstructionService
      .getDeliveryInstruction(this.returnAccountNo)
      .subscribe(
        (result) => {
          if (result.length > 0) {
            result.forEach(x => {
              x.selectedDeliveryInstructions = x.deliveryInstructions ? x.deliveryInstructions.split(',') : [];
              x.isDeliveryInstructionsDisabled = x.packagedType == 'BULK' ? true : false;
              x.packagedTypeDisabled = true;
            });
            this.selectedFormData.accountNumber = this.returnAccountNo;
            const tempData = result
              .sort((a, b) => b - a)
              .map((x, count) => {
                x['id'] = count + 1;
                x['lineErrors'] = new LineError();
                x['lineError'] = false;
                x['toBeValidated'] = false;
                return x;
              });
            this.selectedFormData.deliveryInstructionsData = tempData;
            this.selectedFormData.updatedBy = tempData[0].updateUser;
            this.selectedFormData.dateUpdated = this.datepipe.transform(
              tempData[0].updateTimeStamp,
              'MM/dd/yyyy'
            );
            this.deliveryInstructionDS = new MatTableDataSource(result);
            this.originalProductItemsDataSource = new MatTableDataSource(JSON.parse(JSON.stringify(result)));

            this.loaderService.setLoaderStatus(false);
          }
        },
        (error) => LolLoggerService.error(error)
      ));
  }

  getDeliveryInstructionsDetailsByAccount(accountNumber: any) {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.cppDeliveryInstructionService
      .getDeliveryInstruction(accountNumber)
      .subscribe(
        (result) => {
          if (result.length > 0) {
            result.forEach(x => {
              x.selectedDeliveryInstructions = x.deliveryInstructions ? x.deliveryInstructions.split(',') : [];
              x.isDeliveryInstructionsDisabled = x.packagedType == 'BULK' ? true : false;
              x.packagedTypeDisabled = true;
            });
            this.selectedFormData.accountNumber = accountNumber;
            const tempData = result
              .sort((a, b) => b - a)
              .map((x, count) => {
                x['id'] = count + 1;
                x['lineErrors'] = new LineError();
                x['lineError'] = false;
                x['toBeValidated'] = false;
                return x;
              });
            this.selectedFormData.deliveryInstructionsData = tempData;
            this.selectedFormData.updatedBy = tempData[0].updateUser;
            this.selectedFormData.dateUpdated = this.datepipe.transform(
              tempData[0].updateTimeStamp,
              'MM/dd/yyyy'
            );
            this.deliveryInstructionDS = new MatTableDataSource(result);
            this.originalProductItemsDataSource = new MatTableDataSource(JSON.parse(JSON.stringify(result)));
            this.returnAccountNo = accountNumber;
            this.loaderService.setLoaderStatus(false);
          }
          else {
            this.loaderService.setLoaderStatus(false);
            this.deliveryInstructionDS = new MatTableDataSource();
            this.originalProductItemsDataSource = new MatTableDataSource();
            this.returnAccountNo = accountNumber;
          }
        },
        (error) => LolLoggerService.error(error)
      ));
  }

  // Set Dynamic Height of the Modified product listing table
  setSeedEditPageHeight() {
    const seedEditHeight =
      window.innerHeight -
      $('.navbar').outerHeight() -
      $('.SeedFulfillBtnSec').outerHeight();
    $('.seedEfulfillmentOuter').css('height', seedEditHeight + 'px');
  }

  navigateToDeliveryinstructions() {
    this.router.navigate(['/cpp/cpp-delivery-instructions']);
  }

  checkAnyValidLineItem() {
    const errorCount = this.deliveryInstructionDS.data.filter(
      (x) => x.lineErrors.errors.length > 0
    ).length;
    return errorCount > 0 ? false : true;
  }

  enableSaveDeliveryInstruction() {
    if (
      this.deliveryInstructionDS &&
      this.deliveryInstructionDS.data.length > 0 &&
      this.selectedFormData.accountNumber &&
      this.checkAnyValidLineItem()
    ) {
      this.isSubmitEnable = true;
    } else {
      this.isSubmitEnable = false;
    }
  }

  CompareArray(result1, result2) {
    // Find values that are in result1 but not in result2
    const uniqueResultOne = result1.filter(function (obj) {
      return !result2.some(function (obj2) {
        return obj.value == obj2.value;
      });
    });

    // Find values that are in result2 but not in result1
    const uniqueResultTwo = result2.filter(function (obj) {
      return !result1.some(function (obj2) {
        return obj.value == obj2.value;
      });
    });
    return uniqueResultOne.length == 0 && uniqueResultTwo.length == 0;
  }

  validateOrder() {
    let isValidated = true;
    if (this.deliveryInstructionDS.data && this.deliveryInstructionDS.data.length > 0) {
      isValidated = true;
      this.deliveryInstructionDS.data.forEach((x) => {
        x = this.validateDeliveryDS(x);
        if (x.lineErrors.errors.length > 0) {
          isValidated = false;
        }
      });

      //  if (this.deliveryInstructionDS.data.length > 1) {
      //    var firstContactType = this.deliveryInstructionDS.data[0].contactType;
      //     var check = this.deliveryInstructionDS.data.filter(
      //      (y) => y.contactType == firstContactType
      //    );
      //    if (check.length > 1) {
      //      isValidated = false;
      //      this.toastrService.error(
      //        "Same combination of Account Number, Packaged Type, and contact type found."
      //      );
      //    }

      //  }
      //}

      let data = _.map(this.deliveryInstructionDS.data, _.partialRight(_.pick, ['packagedType', 'contactType']))
      var isValidContact = _.uniqWith(data, _.isEqual).length === data.length;

      if (!isValidContact) {
        isValidated = isValidContact;
        this.toastrService.error(
          "Limit of 2 Contact Type per Package Type allowed."
        );
      }
    }
    return isValidated;
  }
  // Hide & show common error
  getCommonErrors(errors: any) {
    if (errors && errors.length > 0) {
      this.index = 0;
      this.currentErrorRow = 1;
      this.errorMsgs = errors;
      this.showErrorBlock = true;
    } else {
      this.showErrorBlock = false;
    }
  }

  // Show the next error
  nextError() {
    this.index = this.errorMsgs.findIndex((x) => x.id == this.nextErrorId) + 1;
    if (this.errorMsgs.indexOf(this.errorMsgs[this.index]) != -1) {
      this.nextErrorId = this.errorMsgs[this.index].id;
      this.currentErrorRow = this.index + 1;
      $('#returnRequestView').scrollTop = 0;
      if ($('#error_' + this.nextErrorId.toString()).offset()) {
        const nextOffset = $('#error_' + this.nextErrorId.toString()).offset()
          .top;
        $('#returnRequestView').animate({ scrollTop: nextOffset }, 1000);
      }
    } else {
      this.index = 0;
      this.nextErrorId = this.errorMsgs[this.index].id;
      this.currentErrorRow = 1;
      $('#returnRequestView').scrollTop = 0;
      $('#returnRequestView').animate({ scrollTop: 0 }, 1000);
    }
  }

  // To revert changes
  revertToPreviousError(element: any, isSingleLine) {
    if (
      element &&
      element != null &&
      this.originalProductItemsDataSource.data.length > 0 &&
      this.deliveryInstructionDS.data.length > 0
    ) {
      if (element && element != null && isSingleLine) {
        // get old data
        const oldLineValue = this.originalProductItemsDataSource.data.filter(
          (x) => x.id === element.id
        )[0];
        oldLineValue.lineErrors = { itemId: oldLineValue.id, errors: [] };

        // get current object index
        const currentLineIndex = this.deliveryInstructionDS.data.findIndex(
          (x) => x.id === element.id
        );

        // replace current with old object if exist
        if (currentLineIndex != -1) {
          const tempData = this.deliveryInstructionDS.data;
          const oldData = JSON.parse(JSON.stringify(oldLineValue));
          if (tempData[currentLineIndex].lineErrors.errors && tempData[currentLineIndex].lineErrors.errors.length > 0) {
            tempData[currentLineIndex].lineErrors.errors.forEach(e => {
              const error = JSON.parse(JSON.stringify(e));
              if (error.id == 'firstName') {
                tempData[currentLineIndex].firstName = oldData.firstName;
              }
              else if (error.id == 'lastName') {
                tempData[currentLineIndex].lastName = oldData.lastName;
              }
              else if (error.id == 'contactType') {
                tempData[currentLineIndex].contactType = oldData.contactType;
              }
              else if (error.id == 'phoneNumber') {
                tempData[currentLineIndex].phoneNumber = oldData.phoneNumber;
              }
              else if (error.id == 'deliveryInstrcutionLength') {
                tempData[currentLineIndex].firstName = oldData.firstName;
                tempData[currentLineIndex].phoneNumber = oldData.phoneNumber;
              }
            });
          }
          tempData[currentLineIndex].lineErrors = oldData.lineErrors;
          tempData[currentLineIndex].lineError = oldData.lineError;
          this.deliveryInstructionDS = new MatTableDataSource(tempData);
          const index = this.errorMsgs.findIndex((x) => parseInt(x.itemId) == oldLineValue.id);
          if (index !== -1) {
            this.errorMsgs.splice(index, 1);
          }
          // to hide one error after revert changes
          this.showHideLineError(oldLineValue.id);
          this.getCommonErrors(this.errorMsgs);
        }
      } else {
        // replace whole object

        // replace the new value with old value if it has error;
        this.deliveryInstructionDS.data.forEach(x => {
          if (x.lineErrors.errors && x.lineErrors.errors.length > 0) {
            const tempData = JSON.parse(JSON.stringify(this.originalProductItemsDataSource.data.filter(o => o.id == x.id)[0]));
            x.lineErrors.errors.forEach(e => {
              const error = JSON.parse(JSON.stringify(e));
              if (error.id == 'firstName') {
                x.firstName = tempData.firstName;
              }
              else if (error.id == 'lastName') {
                x.lastName = tempData.lastName;
              }
              else if (error.id == 'contactType') {
                x.contactType = tempData.contactType;
              }
              else if (error.id == 'phoneNumber') {
                x.phoneNumber = tempData.phoneNumber;
              }
              else if (error.id == 'deliveryInstrcutionLength') {
                x.firstName = tempData.firstName;
                x.phoneNumber = tempData.phoneNumber;
              }
            });
          }

          x.lineErrors = { itemId: x.id, errors: [] };
        });
        // To hide common error msg
        this.errorMsgs = new Array();
      }
    }
    if (this.errorMsgs.length > 0) {
      this.isSubmitEnable = false;
    }
    this.enableSaveDeliveryInstruction();
  }

  // Revert all changes
  revertAllChanges() {
    this.revertToPreviousError([], false);
    this.hideCommonError();
    this.enableSaveDeliveryInstruction();
  }

  // Hide common error
  hideCommonError() {
    this.showErrorBlock = false;
    this.isSearchClicked = true;
    this.editToolKit = false;
  }

  // Hide and show error line error
  showHideLineError(errorId: number) {
    if (errorId > 0) {
      const errorDiv = $('#error_' + errorId.toString());
      if (errorDiv) {
        errorDiv.hide();
      }
    } else {
      if (this.errorMsgs && this.errorMsgs.length > 0) {
        this.errorMsgs.forEach((x) => {
          const errorDiv = $('#error_' + x.rowId.toString());
          if (errorDiv) {
            errorDiv.show();
          }
        });
      }
    }
  }

  validateDeliveryFeildDS(productItem: any, fieldName: any) {
    if (fieldName === 'contactType') {
      if (productItem.contactType === '' || productItem.contactType === '') {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'contactType'
        );
        productItem.lineErrors.errors.push({
          id: 'contactType',
          error: 'Please select a contact type',
        });
        productItem.lineErrors.itemId = productItem.id;
      } else {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'contactType'
        );
        var index = this.errorMsgs.findIndex(function (element) {
          return element.itemId === productItem.id;
        });
        if (index !== -1) {
          this.errorMsgs.splice(index, 1);
        }
      }
    }
    if (fieldName === 'firstName') {
      if (productItem.firstName === '' || productItem.firstName === '') {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'firstName'
        );
        productItem.lineErrors.errors.push({
          id: 'firstName',
          error: 'Please enter a first name',
        });
        productItem.lineErrors.itemId = productItem.id;
      } else {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'firstName'
        );
        var index = this.errorMsgs.findIndex(function (element) {
          return element.itemId === productItem.id;
        });
        if (index !== -1) {
          this.errorMsgs.splice(index, 1);
        }
      }
    }
    if (fieldName === 'lastName') {
      if (productItem.lastName === '' || productItem.lastName === '') {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'lastName'
        );
        productItem.lineErrors.errors.push({
          id: 'lastName',
          error: 'Please enter a last name',
        });
        productItem.lineErrors.itemId = productItem.id;
      } else {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'lastName'
        );
        var index = this.errorMsgs.findIndex(function (element) {
          return element.itemId === productItem.id;
        });
        if (index !== -1) {
          this.errorMsgs.splice(index, 1);
        }
      }
    }
    if (fieldName === 'phoneNumber') {
      if (productItem.phoneNumber === '' || productItem.phoneNumber === '') {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'phoneNumber'
        );
        productItem.lineErrors.errors.push({
          id: 'phoneNumber',
          error: 'Please enter a phone number',
        });
        productItem.lineErrors.itemId = productItem.id;
      } else {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'phoneNumber'
        );
        var index = this.errorMsgs.findIndex(function (element) {
          return element.itemId === productItem.id;
        });
        if (index !== -1) {
          this.errorMsgs.splice(index, 1);
        }
        if (
          productItem.phoneNumber !== '' ||
          productItem.phoneNumber !== ''
        ) {
          if (productItem.phoneNumber.length < 10) {
            productItem.lineErrors.errors.push({
              id: 'phoneNumber',
              error: 'Please enter a valid phone number',
            });
            productItem.lineErrors.itemId = productItem.id;
          }
        }
        else {
          productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
            (y) => y.id != 'phoneNumber'
          );
          var index = this.errorMsgs.findIndex(function (element) {
            return element.itemId === productItem.id;
          });
          if (index !== -1) {
            this.errorMsgs.splice(index, 1);
          }
        }
      }
    }
    if (fieldName === 'firstName' || fieldName === 'lastName') {
      if (productItem.firstName === '' && productItem.lastName === '') {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'deliveryInstrcutionLength'
        );
        var index = this.errorMsgs.findIndex(function (element) {
          return element.itemId === productItem.id;
        });
      } else {
        let fieldLength = 0;

        // Set the length of first name or last name based on data
        if (productItem.firstName !== '' && productItem.phoneNumber !== '') {
          fieldLength = (productItem.firstName?.length) + 1 + (productItem.phoneNumber?.length);
        } else {
          fieldLength = (productItem.firstName?.length) + (productItem.phoneNumber?.length);
        }

        // Get and Set the length of delivery instrcutions

        if (fieldLength > 60) {
          productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
            (y) => y.id != 'deliveryInstrcutionLength'
          );
          productItem.lineErrors.errors.push({
            id: 'deliveryInstrcutionLength',
            error: this.MaxlengthErrorMsg,
          });
          productItem.lineErrors.itemId = productItem.id;
        } else {
          productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
            (y) => y.id != 'deliveryInstrcutionLength'
          );
          var index = this.errorMsgs.findIndex(function (element) {
            return element.itemId === productItem.id;
          });
        }
      }
    }

    if (productItem.lineErrors.errors.length > 0) {
      if ((this.errorMsgs.filter((x) => x.itemId == productItem.id)).length > 0) {
        this.errorMsgs.map((x) => {
          if (x.itemId == productItem.id) {
            x['errors'] = productItem.lineErrors.errors;
            return x;
          }
        });
      }
      else {
        this.errorMsgs.push(productItem.lineErrors);
      }
      this.getCommonErrors(this.errorMsgs);
    }
    return productItem;
  }

  validateDeliveryDS(productItem: any) {
    if (!productItem.toBeValidated || this.isSaveClicked) {
      if (productItem.contactType === '' || productItem.contactType === '') {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'contactType'
        );
        productItem.lineErrors.errors.push({
          id: 'contactType',
          error: 'Please select a contact type',
        });
        productItem.lineErrors.itemId = productItem.id;
      } else {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'contactType'
        );
        var index = this.errorMsgs.findIndex(function (element) {
          return element.itemId === productItem.id;
        });
        if (index !== -1) {
          this.errorMsgs.splice(index, 1);
        }
      }
      if (productItem.firstName === '' || productItem.firstName === '') {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'firstName'
        );
        productItem.lineErrors.errors.push({
          id: 'firstName',
          error: 'Please enter a first name',
        });
        productItem.lineErrors.itemId = productItem.id;
      } else {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'firstName'
        );
        var index = this.errorMsgs.findIndex(function (element) {
          return element.itemId === productItem.id;
        });
        if (index !== -1) {
          this.errorMsgs.splice(index, 1);
        }
      }
      if (productItem.lastName === '' || productItem.lastName === '') {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'lastName'
        );
        productItem.lineErrors.errors.push({
          id: 'lastName',
          error: 'Please enter a last name',
        });
        productItem.lineErrors.itemId = productItem.id;
      } else {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'lastName'
        );
        var index = this.errorMsgs.findIndex(function (element) {
          return element.itemId === productItem.id;
        });
        if (index !== -1) {
          this.errorMsgs.splice(index, 1);
        }
      }
      if (productItem.phoneNumber === '' || productItem.phoneNumber === '') {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'phoneNumber'
        );
        productItem.lineErrors.errors.push({
          id: 'phoneNumber',
          error: 'Please enter a phone number',
        });
        productItem.lineErrors.itemId = productItem.id;
      } else {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'phoneNumber'
        );
        var index = this.errorMsgs.findIndex(function (element) {
          return element.itemId === productItem.id;
        });
        if (index !== -1) {
          this.errorMsgs.splice(index, 1);
        }
        if (
          productItem.phoneNumber !== '' ||
          productItem.phoneNumber !== ''
        ) {
          if (productItem.phoneNumber.length < 10) {
            productItem.lineErrors.errors.push({
              id: 'phoneNumber',
              error: 'Please enter a valid phone number',
            });
            productItem.lineErrors.itemId = productItem.id;
          }
        }
        else {
          productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
            (y) => y.id != 'phoneNumber'
          );
          var index = this.errorMsgs.findIndex(function (element) {
            return element.itemId === productItem.id;
          });
          if (index !== -1) {
            this.errorMsgs.splice(index, 1);
          }
        }
      }
    }

    if (productItem.lineErrors.errors.length > 0) {
      this.errorMsgs.push(productItem.lineErrors);
      this.getCommonErrors(this.errorMsgs);
    }
    return productItem;
  }

  saveDeliveryInstructions() {
    this.isSaveClicked = true;
    if (this.validateOrder()) {
      if (this.deliveryInstructionDS.data.length > 0) {
        this.deliveryInstructionDS.data.map((x) => {
          x['accountNumber'] = this.selectedFormData.accountNumber;
          x.deliveryInstructions = x.selectedDeliveryInstructions ? x.selectedDeliveryInstructions.join(',') : '';
          return x;
        });
      }
      this.loaderService.setLoaderStatus(true);
      this.subscription.push(this.cppDeliveryInstructionService
        .saveDeliveryInstruction(this.deliveryInstructionDS.data)
        .subscribe(
          (result) => {
            if (this.isEditMode) {
              this.toastrService.success(
                'Delivery Instructions updated successfully.'
              );
            } else {
              this.toastrService.success(
                'Delivery Instructions saved successfully.'
              );
            }
            this.returnAccountNo = this.selectedFormData.accountNumber;
            this.getDeliveryInstructionsDetails();
            this.loaderService.setLoaderStatus(false);
          },
          (error) => LolLoggerService.error(error)
        ));
    }
    else {
      this.isSaveClicked = false;
      const prevData = this.deliveryInstructionDS.data;
      prevData.map((x) => {
        x['toBeValidated'] = false;
        return x;
      });
      this.deliveryInstructionDS = new MatTableDataSource(prevData);
      this.originalProductItemsDataSource = new MatTableDataSource(JSON.parse(JSON.stringify(prevData)));
    }
  }
  // Go to landing cpp delivery page
  navigateTolandingCppDelivery() {
    this.router.navigate(['/cpp/cpp-delivery-instructions']);
  }

  // Get the shipto and  deliver to for dropdown DeliverTo
  getShipToAndDeliverToData() {
    this.subscription.push(this.cppDeliveryInstructionService
      .getDeliveryInstructionAccountList()
      .subscribe(
        (result) => {
          this.shipToData = result;
          this.shipToDataLoading = false;
        },
        (error) => LolLoggerService.error(error)
      ));
  }
  // Search the account details on shipto / Deliverto dropdown
  accountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return (
      item.accountName.toLocaleLowerCase().indexOf(term) > -1 ||
      item.accountNumber.toString().indexOf(term) > -1 ||
      item.address1.toLocaleLowerCase().indexOf(term) > -1 ||
      item.city.toLocaleLowerCase().indexOf(term) > -1 ||
      item.state.toLocaleLowerCase().indexOf(term) > -1 ||
      item.zipCode.toLocaleLowerCase().indexOf(term) > -1
    );
  }

  public ngOnDestroy(): void {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
